
import { defineComponent, reactive, toRefs } from "vue";
import VueFeather from "vue-feather";
import NewTurbineModal from "@/components/NewTurbineModal.vue";
import NewCustomerModal from "@/components/NewCustomerModal.vue";
import NewAggregatorModal from "@/components/NewAggregatorModal.vue";
import NewTurbineModelModal from "@/components/NewTurbineModelModal.vue";
import NewBladeModelModal from "@/components/NewBladeModelModal.vue";

export default defineComponent({
  name: "CommissioningPage",
  components: {
    VueFeather,
    NewTurbineModal,
    NewCustomerModal,
    NewAggregatorModal,
    NewTurbineModelModal,
    NewBladeModelModal,
  },
  setup() {
    const state = reactive({
      showNewTurbineModal: false as boolean,
      showNewCustomerModal: false as boolean,
      showNewAggregatorModal: false as boolean,
      showNewTurbineModelModal: false as boolean,
      showNewBladeModelModal: false as boolean,
    });

    const openNewTurbineModal = () => {
      state.showNewTurbineModal = true;
    };
    const closeNewTurbineModal = () => {
      state.showNewTurbineModal = false;
    };
    const openNewCustomerModal = () => {
      state.showNewCustomerModal = true;
    };
    const closeNewCustomerModal = () => {
      state.showNewCustomerModal = false;
    };
    const openNewAggregatorModal = () => {
      state.showNewAggregatorModal = true;
    };
    const closeNewAggregatorModal = () => {
      state.showNewAggregatorModal = false;
    };
    const openNewTurbineModelModal = () => {
      state.showNewTurbineModelModal = true;
    };
    const closeNewTurbineModelModal = () => {
      state.showNewTurbineModelModal = false;
    };
    const openNewBladeModelModal = () => {
      state.showNewBladeModelModal = true;
    };
    const closeNewBladeModelModal = () => {
      state.showNewBladeModelModal = false;
    };

    return {
      ...toRefs(state),
      openNewTurbineModal,
      closeNewTurbineModal,
      openNewCustomerModal,
      closeNewCustomerModal,
      openNewAggregatorModal,
      closeNewAggregatorModal,
      openNewTurbineModelModal,
      closeNewTurbineModelModal,
      openNewBladeModelModal,
      closeNewBladeModelModal,
    };
  },
});
